import { useEffect } from 'react';
import { Button } from '@cbhq/cds-web/buttons';
import { VStack } from '@cbhq/cds-web/layout';
import { TextTitle1, TextTitle3 } from '@cbhq/cds-web/typography';

import { BuildQuestModal } from ':cloud/widgets/buildQuest/BuildQuestModal';
import { useBuildQuestContext } from ':cloud/widgets/buildQuest/BuildQuestProvider';
import { createConfetti } from ':cloud/widgets/buildQuest/confetti';

type BuildQuestModalProps = {
  onRequestClose: () => void;
  visible: boolean;
};

export function LevelUpModal({ onRequestClose, visible }: BuildQuestModalProps) {
  const { playerLevel, currentLevelColor, togglePrizesModalOn } = useBuildQuestContext();

  useEffect(() => {
    if (visible) {
      createConfetti();
    }
  }, [visible]);

  return (
    <BuildQuestModal onRequestClose={onRequestClose} visible={visible}>
      <VStack width="100%" height="100%" justifyContent="space-between" alignItems="center">
        <VStack
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          spacingBottom={6}
        >
          <TextTitle1 as="h3" align="center">
            Congratulations!
          </TextTitle1>
          {playerLevel === 4 ? (
            <TextTitle3 as="p" spacingTop={5} spacingBottom={2} align="center">
              You completed CDP Quest!
            </TextTitle3>
          ) : (
            <TextTitle3 as="p" spacingTop={5} spacingBottom={2} align="center">
              You leveled up to level {playerLevel} and unlocked new prizes.
            </TextTitle3>
          )}
        </VStack>
        <VStack width="100%" justifyContent="center" alignItems="center" spacing={3}>
          <Button onPress={togglePrizesModalOn} transparent>
            <TextTitle3 as="p" dangerouslySetColor={currentLevelColor}>
              Claim your prizes →
            </TextTitle3>
          </Button>
        </VStack>
      </VStack>
    </BuildQuestModal>
  );
}
